import Cookies from 'js-cookie';
import { i18n } from '~/plugins/i18n';
import store from '~/store';
import { ensureAuthenticationToken } from './apollo';

const { fetch: originalFetch } = window;
/**
 * Shows the disconnect modal
 */
function showDisconnectionModal() {
  store.commit('auth/commitShowDisconnectModal', true);
}

// Request interceptor to append the locale and authorization to the headers
const kpwebFetch = async function (...args) {
  const [resource, config] = args;
  const overrideConfig = config || {};
  const currentHeaders = overrideConfig?.headers || {};
  // Making sure we have the correct "Accept" in headers
  currentHeaders.Accept = 'application/json';
  const locale = i18n.global.locale.value;
  if (locale) {
    currentHeaders['Accept-Language'] = locale;
    overrideConfig.headers = currentHeaders;
  }

  await ensureAuthenticationToken();
  const currentToken = Cookies.get('token');
  if (!currentToken) {
    showDisconnectionModal();
    return;
  }

  // Perform the request and always return the Response object so callers can inspect it.
  try {
    const response = await originalFetch(resource, overrideConfig);

    if (response?.status === 401) {
      // Trigger the disconnect modal but still give the caller the response
      showDisconnectionModal();
    }

    //  eslint-disable-next-line
    return response;
  } catch (error) {
    if (error?.status === 401) {
      showDisconnectionModal();
    }
    throw error;
  }
};

export { kpwebFetch };

export default {
  install: (app) => {
    // eslint-disable-next-line no-param-reassign
    app.config.globalProperties.$kpwebFetch = kpwebFetch;
  },
};
